export default {
  templateDash_setDashboards(state, dashboards) {
    state.templateDash_dashboards = dashboards
  },
  templateDash_setDashboardsInUse(state, dashboards) {
    state.templateDash_dashboardsInUse = dashboards
  }
}
